

export const ACCEPTED = "Accepted";
export const DECLINED = "Declined";
export const PENDING = "Pending";